import React from 'react';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import BottomSheet from 'components/BottomSheet';
import ModalHeader from 'components/ModalHeader';
import { Desktop, Mobile } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Content, SearchButton, ClearButton, Header, Close, ButtonContainer } from './styles';

export { default as FilterItem } from './components/FilterItem';
export { default as PriceFilter } from './components/Price';
export { default as Select } from './components/Select';

interface Props {
  show: boolean;
  showSearchButton: boolean;
  children: JSX.Element | JSX.Element[];
  onSearch: () => void;
  onClose: () => void;
  filtersCount?: number;
  onClearFilter?: () => void;
}

const FiltersBottomSheet = ({
  show,
  showSearchButton,
  children,
  onSearch,
  onClose,
  filtersCount,
  onClearFilter,
}: Props) => {
  const { t } = useStoreTranslation();

  const content = () => (
    <>
      <Content>{children}</Content>
      {showSearchButton && (
        <ButtonContainer>
          <SearchButton onClick={onSearch} value={t('filters.searchButton')} />
        </ButtonContainer>
      )}
    </>
  );

  return (
    <>
      <Mobile>
        <BottomSheet show={show} onClose={onClose} noHeader>
          <Header>
            {filtersCount && filtersCount > 0 ? (
              <ClearButton onClick={onClearFilter}>
                {t('filters.clearButton')} ({filtersCount})
              </ClearButton>
            ) : (
              <ClearButton disabled>{t('filters.clearButton')}</ClearButton>
            )}
            <Header.Title>{t('filters.title')}</Header.Title>
            <Close onClick={onClose}>
              <Close.Icon />
            </Close>
          </Header>
          {content()}
        </BottomSheet>
      </Mobile>
      <Desktop>
        <ApplicationOverlayContent show={show} onClose={onClose}>
          <Container>
            <ModalHeader title={t('filters.title')} onClose={onClose} />
            {content()}
          </Container>
        </ApplicationOverlayContent>
      </Desktop>
    </>
  );
};

export default FiltersBottomSheet;
